import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatsAppButton() {
  return <motion.a href="https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20bd5a] transition-colors duration-300" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} data-id="element-142" data-mp="1sdsf9f5fo9je">
      <motion.div animate={{
      boxShadow: ['0 0 0 0 rgba(37, 211, 102, 0.7)', '0 0 0 15px rgba(37, 211, 102, 0)', '0 0 0 0 rgba(37, 211, 102, 0)']
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute inset-0 rounded-full" data-id="element-143" data-mp="2zr3ytorexmql" />
      <MessageCircle size={32} className="relative z-10" data-id="element-144" data-mp="ia9cda6k2oo3" />
    </motion.a>;
}